export default {
    namespaced: true,
    state: {
        nav_dropdown_open: false,
    },
    mutations: {
        dropdown_open(state) {
            state.nav_dropdown_open = true;
        },
        dropdown_close(state) {
            state.nav_dropdown_open = false;
        }
    },
    actions: {

    },
    getters: {
        is_open: (state) => state.dropdown_open,
    }
};